import {
    BILLETTERIE_CATALOG_REF,
    REQUEST_BILLETTERIE_PARTNERS,
    RECEIVE_BILLETTERIE_PARTNERS,
    FAILURE_BILLETTERIE_PARTNERS
} from './constants';

import { CALL_API } from '../../middlewares/api';

const shouldFetchBilletteriePartners = state =>
    !state.billetterie.fetching && !state.billetterie.fetched;

// Mur de la zone (daté + non daté) : seule source qui identifie un marchand billetterie
const BILLETTERIE_PARTNERS_ENDPOINT = `/billetterie/partner?pricingType=ALL&catalogRef=${BILLETTERIE_CATALOG_REF}`;
const BILLETTERIE_PARTNERS_TYPES = [
    REQUEST_BILLETTERIE_PARTNERS,
    RECEIVE_BILLETTERIE_PARTNERS,
    FAILURE_BILLETTERIE_PARTNERS
];

export const fetchBilletteriePartnersIfNeeded = () => {
    return {
        [CALL_API]: {
            endpoint: BILLETTERIE_PARTNERS_ENDPOINT,
            types: BILLETTERIE_PARTNERS_TYPES,
            shouldCallAPI: state => shouldFetchBilletteriePartners(state)
        }
    };
};

// Cashback (donc remise) selon les segments du membre : à recharger à la connexion et à la déconnexion
export const forceFetchBilletteriePartners = () => {
    return {
        [CALL_API]: {
            endpoint: BILLETTERIE_PARTNERS_ENDPOINT,
            types: BILLETTERIE_PARTNERS_TYPES
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/billetterie/actions.js